import { gql } from "@apollo/client";

export const PUBLISH_PAGE_LAYOUT_MUTATION = gql`
  mutation PublishPageLayout($input: PublishPageLayoutInput!) {
    publishPageLayout(input: $input) {
      statusCode
      message
      status
    }
  }
`;
